import { render } from "./createService.vue?vue&type=template&id=2355d613"
import script from "./createService.vue?vue&type=script&lang=js"
export * from "./createService.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__